import React from "react";
import SimpleModal from "../SimpleModal";
import ProfileTableNoDataResolver from "../ProfilesDetail/Table/NoDataView/resolver";
import styled from "styled-components";
import {
  profileLinkingModalSchemaResolver,
  profilesMachineNameResolver,
  modalTableColumnsResolver,
} from "./utils";
import ProfileSearch from "./ProfileSearch";
import { ReactTable } from "../SimpleForm/ReactTable";

const ModalBody = styled.div`
  padding: 1rem;
`;
const ModalActionToolbar = styled.div`
  display: flex;
  padding: 1rem;
  button {
    margin-left: auto;
  }
`;

const ProfileLinkingModal = ({
  type,
  searchType,
  linkingType,
  formApi,
  loading,
  profiles,
  setClose,
  linkedProfiles,
  setLinkedProfiles,
  open,
  getDataSearch,
  setSearch,
  search,
  user,
  setProfiles,
  setLoading,
  dataReset,
}) => {
  const machine_name = profilesMachineNameResolver(type);
  const modalSchema = profileLinkingModalSchemaResolver(type);
  const columns = modalTableColumnsResolver(
    type,
    linkedProfiles,
    setLinkedProfiles
  );
  const noData = ProfileTableNoDataResolver(linkingType);

  return (
    <SimpleModal
      toggleModal={() => {
        getDataSearch(null, type, user, setProfiles, setLoading);
        setClose();
      }}
      modalStatus={open}
      renderButton={() => null}
      minWidth="70%"
    >
      <h3>{modalSchema.title}</h3>
      <ModalBody>
        <p>{modalSchema.headerText}</p>
        <ProfileSearch
          setSearch={setSearch}
          getDataSearch={getDataSearch}
          dataReset={dataReset}
          search={search}
          user={user}
          setProfiles={setProfiles}
          setLoading={setLoading}
          type={type}
          searchType={searchType}
        />
        <ReactTable
          columns={columns}
          tableTheme="genericTheme"
          data={profiles}
          noDataComponent={noData}
          loading={loading}
          showPagination={!!profiles ? profiles.length > 5 : false}
          defaultSorted={[
            {
              id: columns[1].id,
              asc: true,
            },
          ]}
        />
      </ModalBody>
      <ModalActionToolbar>
        <button
          className="usa-button btn-extra-wide"
          onClick={() => {
            getDataSearch(null, type, user, setProfiles, setLoading);
            formApi.change(machine_name, linkedProfiles);
            setClose();
          }}
        >
          {modalSchema.saveBtnText}
        </button>
      </ModalActionToolbar>
    </SimpleModal>
  );
};

export default ProfileLinkingModal;
